module.exports = "pegasus_template/assets/themelp1/small/bg0.png";